import React from "react";
import { Helmet } from "react-helmet-async";

import {
  FaHotel,
  FaAward,
  FaStar,
  FaShieldAlt,
  FaSearchDollar,
  FaUsers
} from "react-icons/fa";

import aboutImg from "../assets/images/aboutUs.jpg";


export default function AboutUs() {


  const features = [
    {
      icon: <FaAward />,
      title: "Best Hotel Deals",
      text: "Exclusive offers from premium hotels across UAE."
    },
    {
      icon: <FaShieldAlt />,
      title: "Verified Properties",
      text: "Every hotel is carefully selected for quality."
    },
    {
      icon: <FaUsers />,
      title: "Trusted By Travelers",
      text: "Thousands of guests choose us every year."
    }
  ];


  const categories = [
    "Luxury Hotels",
    "Beach Resorts",
    "Family Hotels",
    "Business Hotels"
  ];


  return (

    <>

      <Helmet>
        {/* Basic SEO */}
        <title>About Us | UAE Dubai Hotels</title>

        <meta
          name="description"
          content="Learn more about UAE Dubai Hotels. We help travelers discover luxury, business, family, and budget hotels across Dubai and the UAE with competitive rates and a seamless booking experience."
        />

        <meta
          name="keywords"
          content="About UAE Dubai Hotels, Dubai hotels, UAE hotel booking, luxury hotels Dubai, hotel deals UAE, travel accommodation"
        />

        <meta name="robots" content="index, follow" />
        <meta name="author" content="UAE Dubai Hotels" />

        {/* Canonical */}
        <link
          rel="canonical"
          href="https://uaedubaihotels.com/about"
        />

        {/* Open Graph */}
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="UAE Dubai Hotels" />
        <meta property="og:locale" content="en_US" />

        <meta
          property="og:title"
          content="About Us | UAE Dubai Hotels"
        />

        <meta
          property="og:description"
          content="Learn about UAE Dubai Hotels and our mission to provide the best hotel booking experience across Dubai and the UAE."
        />

        <meta
          property="og:url"
          content="https://uaedubaihotels.com/about"
        />

        <meta
          property="og:image"
          content="https://uaedubaihotels.com/images/default-og.png"
        />

        {/* Twitter */}
        <meta
          name="twitter:card"
          content="summary_large_image"
        />

        <meta
          name="twitter:title"
          content="About Us | UAE Dubai Hotels"
        />

        <meta
          name="twitter:description"
          content="Learn about UAE Dubai Hotels and our mission to provide the best hotel booking experience across Dubai and the UAE."
        />

        <meta
          name="twitter:image"
          content="https://uaedubaihotels.com/images/default-og.png"
        />
      </Helmet>



      <div className="
bg-[#FCFAF5]
dark:bg-gray-950
">





        {/* HERO */}

        <section
          className="
relative
h-[380px]
md:h-[420px]
flex
items-center
bg-cover
bg-center
"
          style={{
            backgroundImage: `url(${aboutImg})`
          }}
        >

          <div className="
absolute
inset-0
bg-gradient-to-r
from-black/80
via-black/50
to-transparent
"/>


          <div className="
relative
container
mx-auto
px-6
">

            <div className="
max-w-2xl
text-white
">


              <span className="
inline-block
bg-[#B89442]/20
border
border-[#B89442]
px-4
py-1.5
rounded-full
text-xs
tracking-[0.2em]
uppercase
">
                UAE Hotel Experts
              </span>



              <h1
                className="
        mt-5
        text-2xl
        sm:text-3xl
        md:text-5xl
        font-serif
        leading-tight
    "
              >
                Experience Luxury
                Stays Across UAE
              </h1>



              <p className="
mt-4
text-sm
md:text-base
text-white/80
max-w-lg
leading-relaxed
">

                Discover handpicked hotels,
                exclusive prices and unforgettable
                experiences in Dubai, Abu Dhabi
                and across UAE.

              </p>



              {/* <button className="
mt-6
px-7
py-3
rounded-full
bg-[#B89442]
text-white
text-sm
font-semibold
hover:bg-[#0F766E]
transition
">

                Explore Hotels →

              </button> */}



            </div>

          </div>


        </section>







        {/* FLOATING STATS */}


        <section
          className="
        container
        mx-auto
        px-4
        -mt-6
        md:-mt-10
        relative
        z-10
    "
        >

          <div
            className="
            bg-white
            dark:bg-gray-900
            rounded-3xl
            shadow-xl
            grid
            grid-cols-3
            p-4
            md:p-8
            border
            border-[#DDD2BA]
        "
          >

            {
              [
                ["500+", "Hotels"],
                ["50K+", "Guests"],
                ["10+", "Years"]
              ].map((item, index) => (

                <div
                  key={index}
                  className="
                        text-center
                        px-2
                        border-r
                        last:border-r-0
                        border-gray-200
                        dark:border-gray-700
                    "
                >

                  <h3
                    className="
                            text-xl
                            sm:text-2xl
                            md:text-3xl
                            font-bold
                            text-[#B89442]
                        "
                  >
                    {item[0]}
                  </h3>

                  <p
                    className="
                            text-xs
                            sm:text-sm
                            md:text-base
                            text-gray-500
                            dark:text-gray-400
                            mt-1
                        "
                  >
                    {item[1]}
                  </p>

                </div>

              ))
            }

          </div>

        </section>







        {/* ABOUT */}


        <section
          className="
        container
        mx-auto
        px-6
        py-24
        grid
        md:grid-cols-2
        gap-14
        items-center
    "
        >

          {/* IMAGE */}
          <div className="order-2 md:order-1">

            <img
              src={aboutImg}
              className="
                rounded-[45px]
                shadow-2xl
            "
            />

          </div>


          {/* CONTENT */}
          <div className="order-1 md:order-2">

            <p
              className="
                uppercase
                tracking-widest
                text-[#0F766E]
                text-sm
            "
            >
              About Us
            </p>


            <h2
              className="
                text-3xl
                md:text-4xl
                font-serif
                mt-4
                dark:text-white
            "
            >
              Making hotel booking
              simple and rewarding
            </h2>


            <p
              className="
                mt-6
                leading-8
                text-gray-600
                dark:text-gray-300
            "
            >
              UAE Discounted Hotels connects travelers
              with carefully selected hotels offering
              exceptional value.
            </p>


            <p
              className="
                mt-4
                leading-8
                text-gray-600
                dark:text-gray-300
            "
            >
              Our goal is to make every stay memorable
              by combining great prices, trusted hotels
              and excellent service.
            </p>


          </div>


        </section>







        {/* FEATURES */}


        <section
          className="
        bg-white
        dark:bg-gray-900
        py-0
        md:py-20
    "
        >


          <div className="
container
mx-auto
px-6
">


            <div className="
grid
md:grid-cols-3
gap-8
">


              {
                features.map((item, index) => (


                  <div
                    key={index}
                    className="
rounded-[35px]
p-8
border
border-[#DDD2BA]
bg-[#FCFAF5]
dark:bg-gray-800
hover:-translate-y-2
transition
"
                  >


                    <div className="
w-16
h-16
rounded-2xl
bg-[#0F766E]
text-white
flex
items-center
justify-center
text-2xl
">

                      {item.icon}

                    </div>


                    <h3 className="
mt-6
text-xl
font-bold
dark:text-white
">

                      {item.title}

                    </h3>


                    <p className="
mt-3
text-gray-500
dark:text-gray-300
">

                      {item.text}

                    </p>


                  </div>


                ))
              }


            </div>


          </div>


        </section>







        {/* HOTEL TYPES */}



        <section className="
container
mx-auto
px-6
py-20
">


          <h2
            className="
        text-center
        text-4xl
        font-serif
        dark:text-white
        !mb-14
    "
          >
            Find Your Perfect Stay
          </h2>



          <div className="
grid
grid-cols-2
md:grid-cols-4
gap-5
">


            {
              categories.map((cat, index) => (


                <div
                  key={index}
                  className="
h-44
rounded-[35px]
bg-[#0F766E]
text-white
flex
items-center
justify-center
text-center
font-semibold
text-lg
hover:bg-[#B89442]
transition
"
                >

                  {cat}

                </div>


              ))
            }


          </div>


        </section>






        {/* MISSION */}


        <section className="
mx-6
rounded-[45px]
bg-[#111827]
py-20
text-center
text-white
mb-20
px-5
">


          <h2 className="
text-4xl
font-serif
">

            Our mission is simple

          </h2>


          <p className="
max-w-3xl
mx-auto
mt-6
text-white/70
leading-8
">

            To help every traveler discover
            amazing UAE hotels at the best prices
            while creating unforgettable memories.

          </p>


        </section>



      </div>


    </>


  )

}